import { connect } from 'react-redux';
import { InsurancePickerDropdownView } from './InsurancePickerDropdownView';
import { getDropdownState } from '../../data/dropdown-state';
import { TAB } from '../../constants';
import { setShowScanCardErrorModal } from '../../data/dropdown-state/dropdownStateActions';

export function mapStateToProps(state) {
    const dropdownState = getDropdownState(state);

    return {
        tab: dropdownState.hasBeenOpened ? dropdownState.tab : TAB.INSURANCE,
        lastTab: dropdownState.lastTab,
        showChange: dropdownState.showChange,
        showSearch: dropdownState.showSearch,
        carrier: dropdownState.carrier,
        plan: dropdownState.plan,
        showingHeaderWithCarrier: dropdownState.carrier
            && (!dropdownState.showSearch || dropdownState.tab === TAB.PLAN),
        showingHeaderWithoutCarrier: !dropdownState.showSearch,
        isScanCardOpen: dropdownState.isScanCardOpen,
        showScanInsuranceCardErrorModal: dropdownState.showScanInsuranceCardErrorModal,
    };
}

export const mapDispatchToProps = {
    setShowScanCardErrorModal,
};

export const InsurancePickerDropdownConnector = connect(
    mapStateToProps,
    mapDispatchToProps
)(InsurancePickerDropdownView);
